module.exports = ":host{display:inline-block;height:var(--lui-line-height);width:var(--lui-line-height)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-spinner/theme/lui-spinner.global.scss
// module id = 322
// module chunks = 0 1 26